import { useNavigate } from 'react-router-dom';
import { typography, radius } from '@/shared/theme/tokens';
import { useAuthStore } from '@/entities/session/model/authStore';
import { PrimaryButton } from '@/shared/ui/PrimaryButton';
import { useThemeColors, useIsDark } from '@/shared/theme/useThemeColors';

export default function ProfileEditPage() {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const c = useThemeColors();
  const isDark = useIsDark();

  return (
    <div style={{ fontFamily: typography.fontFamily.body, maxWidth: '560px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '28px' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: typography.fontSize['4xl'], fontWeight: typography.fontWeight.bold, color: c.textPrimary, fontFamily: typography.fontFamily.heading }}>
            Edit Profile
          </h1>
          <p style={{ margin: '4px 0 0', fontSize: typography.fontSize.md, color: c.textSubtle }}>Manage your account settings</p>
        </div>
        <PrimaryButton variant="secondary" icon="arrow_back" size="sm" onClick={() => navigate(-1)}>
          Back
        </PrimaryButton>
      </div>

      <div style={{
        background: c.bg,
        border: `1px solid ${c.border}`,
        borderRadius: radius['3xl'],
        padding: '60px 40px',
        textAlign: 'center',
        boxShadow: isDark ? 'none' : '0 2px 8px rgba(30,67,150,0.05)',
      }}>
        <div style={{
          width: 56,
          height: 56,
          borderRadius: radius['2xl'],
          background: 'linear-gradient(135deg, #202475, #3EB5E7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px',
          fontSize: typography.fontSize['4xl'],
          fontWeight: typography.fontWeight.bold,
          color: '#ffffff',
          fontFamily: typography.fontFamily.heading,
        }}>
          {getInitials(user?.name ?? user?.email ?? 'U')}
        </div>
        <h2 style={{ margin: '0 0 6px', fontSize: typography.fontSize['2xl'], fontWeight: typography.fontWeight.bold, color: c.textPrimary, fontFamily: typography.fontFamily.heading }}>
          {user?.name ?? user?.email}
        </h2>
        <p style={{ margin: '0 0 24px', fontSize: typography.fontSize.md, color: c.textSubtle }}>{user?.email}</p>
        <p style={{ margin: 0, fontSize: typography.fontSize.base, color: c.textSubtle }}>
          Profile editing coming soon.
        </p>
      </div>
    </div>
  );
}

function getInitials(nameOrEmail) {
  const parts = nameOrEmail.split(/[\s@]/);
  if (parts.length >= 2 && parts[0] && parts[1]) return (parts[0][0] + parts[1][0]).toUpperCase();
  return (parts[0]?.[0] ?? 'U').toUpperCase();
}
